import React, { useEffect, useState, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import {
  Button,
  TableContainer,
  Paper,
  TextField,
  Box,
  FormControl,
  Tabs,
  Tab,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { Checkbox } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  inputStyle,
  StyledButton,
  StyledTypographyA,
  StyledAlert,
  StyledSnackbar,
  ViewButton,
  StyledAgGridContainer,
  StyledCancelButton,
} from "components/StyledComponents/styledComponents.js";
import CurrencyInput from "react-currency-input-field";
import { globalStyles } from "components/Styles/globalStyles";
import { CustomPaper } from "components/Styles/globalStyles";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import { Tooltip, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import PrintIcon from "@mui/icons-material/Print";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import {
  subDialogContentStyle,
  dialogContentTextStyle,
  approvalStyles,
} from "components/Styles/approvalStyles";
import { DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import InvoiceEditor from "components/HeadOffice/HeadOfficenvoice/recovery";
// adjust relative path to your actual recovery.js location

export default function DsaInvoice() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [disbursedData, setDisbursedData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoicedDsa, setInvoicedDSA] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [invoiceDisplayNumber, setInvoiceDisplayNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split("T")[0]);
  const [selectedDSA, setSelectedDSA] = useState(0);
  const [invoicedDsas, setInvoicedDsas] = useState([{ dsa_Id: 0, dsaName: "ALL" }]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [invoicedData, setInvoicedData] = useState([{}]);
  const [dsaInvoiceReceipt, setDsaInvoiceReceipt] = useState([]);
  const [dsaData, setDsaData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [activeTab, setActiveTab] = useState(0);
  const jwt_token = Cookie.get("jwt_token");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [openDailog, setOpenDialog] = useState(false);
  const [confirmPayment, setConfirmPayment] = useState([]);
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [selectedInvoiceEntry, setSelectedInvoiceEntry] = useState({});
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [cancleInvoice, setCancleInvoice] = useState({});
  const [openMisDialog, setOpenMisDialog] = useState(false);
  const [selectedDisbursedIds, setSelectedDisbursedIds] = useState([]);
  const [invoiceTo, setInvoiceTo] = useState({ id: "provider", label: "Provider" });
  const [selectedBank, setSelectedBank] = useState({
    actledId: 0,
    actledName: "",
  });
  const [editableNetDsaAmount, setEditableNetDsaAmount] = useState("");
  const [dsaList, setDsaList] = useState([]);
  const [selectedDsaForInvoice, setSelectedDsaForInvoice] = useState(null);
  const [openGstDialog, setOpenGstDialog] = useState(false);
  const [isGstPaid, setIsGstPaid] = useState(null);
  const [receiptDate, setReceiptDate] = useState(new Date().toISOString().split("T")[0]);
  const [openRecieptDialog, setOpenRecieptDialog] = useState(false);

  // ── Validation error states ──
  const [invoiceNoError, setInvoiceNoError] = useState(false);
  const [invoiceDateError, setInvoiceDateError] = useState(false);

  const handleOpenRecieptDailog = (data) => {
    if (!selectedBank || !selectedBank.actledId) {
      setAlert("Please Select Bank Accounts", "error");
      return;
    }
    setConfirmPayment(data);
    setEditableNetDsaAmount(data.netDsaAmount?.toFixed(2) || "0.00");
    setIsGstPaid(null);
    setOpenGstDialog(true);
  };

  const handleGstSelection = (value) => {
    if (value === null) {
      setAlert("Please select GST Paid status", "error");
      return;
    } else if (value === "Y") {
      const finalAmount = confirmPayment?.totalInvoiceAmount - confirmPayment?.tdsAmount || 0;
      setConfirmPayment((prev) => ({
        ...prev,
        netDsaAmount: finalAmount,
      }));
      setEditableNetDsaAmount(finalAmount);
    } else if (value === "N") {
      const finalAmount = confirmPayment?.amount - confirmPayment?.tdsAmount || 0;
      setConfirmPayment((prev) => ({
        ...prev,
        netDsaAmount: finalAmount,
      }));
      setEditableNetDsaAmount(finalAmount);
    }
    setIsGstPaid(value);
    setOpenGstDialog(false);
    setOpenRecieptDialog(true);
  };

  const handleDateChange = (event) => {
    setReceiptDate(event.target.value);
  };

  const handleCloseRecieptDialog = () => {
    setOpenRecieptDialog(false);
    setEditableNetDsaAmount("");
  };

  const handleRecieptInvoiceDialog = () => {
    if (!selectedBank || !selectedBank.actledId) {
      setAlert("Please Select Bank Accounts", "error");
      return;
    }
    if (!isGstPaid) {
      setAlert("Please select GST Paid status before confirming.", "error");
      return;
    }
    if (!editableNetDsaAmount || parseFloat(editableNetDsaAmount) < 0) {
      setAlert("Please enter a valid Net Amount.", "error");
      return;
    }
    handleConfirmPayment({
      ...confirmPayment,
      netDsaAmount: parseFloat(editableNetDsaAmount),
    });
  };

  const handleBankChange = (event, newValue) => {
    setSelectedBank(newValue);
  };

  const handleCloseDailog = () => setOpenDialog(false);

  const handleConfirmDialog = () => {
    if (!selectedBank || !selectedBank.actledId) {
      setAlert("Please Select Bank Accounts", "error");
      return;
    }
    if (!isGstPaid) {
      setAlert("Please select GST Paid status before confirming.", "error");
      return;
    }
    handleConfirmPayment(confirmPayment);
  };

  const fetchBankAccountsData = async () => {
    setLoading(true);
    const url = `${URLs.headOfficeBanksAcc}/${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    try {
      const response = await fetch(url, options);
      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      setBankAccounts(data);
    } catch (error) {
      setAlert("Failed to fetch bank accounts", "error");
    }
    setLoading(false);
  };

  const handleOpenInvoiceDialog = (data) => {
    setSelectedInvoiceEntry(data);
    setOpenPrintDialog(true);
  };
  const handleCloseInvoiceDialog = () => setOpenPrintDialog(false);

  const handleApproveInvoiceDaialog = () => {
    handlePrintInvoice(selectedInvoiceEntry);
  };

  const handleOpenCancelDialog = (data) => {
    setCancleInvoice(data);
    setOpenCancelDialog(true);
  };
  const handleCloseCancelDialog = () => setOpenCancelDialog(false);

  const handleCancelInvoiceDialog = () => {
    handleCancelInvoice(cancleInvoice);
  };

  // ── Validate Invoice No & Date before opening confirmation dialog ──
  const handleOpenMisDialog = () => {
    let hasError = false;

    if (!invoiceDisplayNumber || invoiceDisplayNumber.trim() === "") {
      setInvoiceNoError(true);
      hasError = true;
    } else {
      setInvoiceNoError(false);
    }

    if (!invoiceDate || invoiceDate.trim() === "") {
      setInvoiceDateError(true);
      hasError = true;
    } else {
      setInvoiceDateError(false);
    }

    if (hasError) {
      setAlert("Please fill in Invoice No. and Invoice Date", "error");
      return;
    }

    setOpenMisDialog(true);
  };

  const handleCloseMisDialog = () => {
    setOpenMisDialog(false);
  };

  const handleMisDialog = () => {
    handleSubmit();
  };

  const ConfirmationDialog = ({ open, onClose, onConfirm, dialogText }) => {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogContent sx={{ mt: 1, ...subDialogContentStyle }}>
          <DialogContentText sx={dialogContentTextStyle}>{dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={onClose} color="secondary">
            Cancel
          </StyledButton>
          <StyledButton onClick={onConfirm} color="primary" autoFocus>
            Confirm
          </StyledButton>
        </DialogActions>
      </Dialog>
    );
  };

  ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    dialogText: PropTypes.string.isRequired,
  };

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const MInput = inputStyle();

  useEffect(() => {
    fetchDsaMasterData();
    if (invoiceTo?.id === "dma") {
      fetchDsaList();
    }
  }, [invoiceTo]);

  useEffect(() => {
    if (activeTab == 1) {
      fetchDsaInvoiceData();
    } else if (activeTab == 0) {
      fetchDisbursedData(3);
      fetchBankAccountsData();
    } else if (activeTab == 2) {
      fetchInvoiceDsaMasterData();
      getDsaInvoicesReceipts();
      fetchBankAccountsData();
    }
  }, [activeTab]);

  const fetchDsaMasterData = async () => {
    const url = URLs.dsaMasterGetUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      const filteredDsaData = data.data.filter((item) => item.dsaStatus == "S");
      setDsaData(filteredDsaData);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };

  const fetchInvoiceDsaMasterData = async () => {
    const url = URLs.invoicedDsaUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setInvoicedDsas((prevData) => [...prevData, ...data]);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };

  const fetchDsaInvoiceData = async () => {
    const url = `${URLs.dsaInvoicedGetUrl}/${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setInvoicedData(data);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const fetchDisbursedData = async () => {
    const url = `${URLs.invoiceEligibleEntriesByDsaId}?dsaId=${user.companyId}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setDisbursedData(data);
      } else {
        setAlert("Failed to fetch data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxClick = (entryId) => {
    setSelectedDisbursedIds((prev) => {
      const updatedIds = prev.includes(entryId)
        ? prev.filter((id) => id !== entryId)
        : [...prev, entryId];

      const updatedRows = disbursedData.filter((row) => updatedIds.includes(row.disburseId));
      setSelectedRows(updatedRows);

      return updatedIds;
    });
  };

  const handleSelectAll = () => {
    if (selectedDisbursedIds.length === disbursedData.length) {
      setSelectedDisbursedIds([]);
      setSelectedRows([]);
    } else {
      setSelectedDisbursedIds(disbursedData.map((row) => row.disburseId));
      setSelectedRows(disbursedData);
    }
  };

  const HeaderCheckbox = () => (
    <Checkbox
      checked={selectedDisbursedIds.length === disbursedData.length && disbursedData.length > 0}
      indeterminate={
        selectedDisbursedIds.length > 0 && selectedDisbursedIds.length < disbursedData.length
      }
      onChange={handleSelectAll}
    />
  );

  const columns = [
    {
      field: "addToInvoice",
      headerName: "Select All",
      headerComponent: HeaderCheckbox,
      align: "center",
      width: 50,
      cellRenderer: (params) => (
        <Checkbox
          checked={selectedDisbursedIds.includes(params.data.disburseId)}
          onChange={() => handleCheckboxClick(params.data.disburseId)}
        />
      ),
    },
    {
      field: "date",
      headerName: "Date",
      sortable: true,
      filter: true,
      width: 130,
      valueFormatter: (params) => formatDate(params.value),
      sort: "desc",
    },
    {
      headerName: "Appl. No.",
      field: "applicationNumber",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 1,
    },
    { field: "customerName", headerName: "Customer Name", sortable: true, filter: true, flex: 1.5 },
    {
      field: "disbursedAmount",
      headerName: "disbursed Amount",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
    {
      field: "businessTypeCode",
      headerName: "Product Type",
      sortable: true,
      filter: true,
      flex: 1,
    },
    {
      field: "financialInstitutionName",
      headerName: "Provider Name",
      sortable: true,
      filter: true,
    },
    {
      field: "grossPayoutPercent",
      headerName: "Revenue (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : ""),
    },
    {
      field: "grossPayoutAmount",
      headerName: "Revenue",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
    {
      field: "dsaPayoutPercent",
      headerName: "DSA Pay-out (%)",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => (params.value ? `${params.value.toFixed(2)}%` : ""),
    },
    {
      field: "dsaPayoutAmount",
      headerName: "DSA Payout",
      sortable: true,
      filter: true,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 }) || "0.00"}`,
    },
  ];

  const fetchDsaList = async () => {
    const url = URLs.dsaMasterGetUrl;
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch DSA list");
      const data = await response.json();
      const filteredDsaData = data.data;
      setDsaList(filteredDsaData);
    } catch (error) {
      setAlert("Failed to fetch DSA list", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (invoiceTo?.id === "dma" && !selectedDsaForInvoice) {
      setAlert("Please select DSA", "error");
      return;
    }
    if (invoiceTo?.id === "provider" && (user.companyId === null || user.companyId === undefined)) {
      setAlert("Please select DSA", "error");
      return;
    }
    if (!selectedDisbursedIds.length > 0) {
      setAlert("Please select Disbursements", "error");
      return;
    }
    if (!invoiceTo) {
      setAlert("Please select Invoice To", "error");
      return;
    }
    if (!selectedBank || !selectedBank.actledId) {
      setAlert("Please select a valid Bank Account", "error");
      return;
    }

    if (selectedDisbursedIds.length > 0) {
      const selectedEntry = disbursedData.find(
        (entry) => entry.disburseId === selectedDisbursedIds[0]
      );

      if (!selectedEntry) {
        setAlert("Selected entry not found", "error");
        return;
      }

      const url = URLs.dsaInvoiceUrl;
      const data = {
        disburseIds: [...selectedDisbursedIds],
        dsa_Id: user.companyId,
        date: invoiceDate,
        invoiceTo: invoiceTo.id === "dma" ? selectedDsaForInvoice?.dsaName : invoiceTo.label,
        customerAccountId:
          invoiceTo.id === "provider"
            ? selectedEntry.bankerActledId
            : selectedDsaForInvoice?.accountId,
        invoiceDisplayNumber: invoiceDisplayNumber,
        dsaBankActledId: selectedBank.actledId,
      };

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(data),
      };
      setLoading(true);
      try {
        const response = await fetch(url, options);
        if (response.ok) {
          const responseData = await response.json();
          setAlert(responseData.message, "success");
          fetchDisbursedData(2);
          setSelectedDSA("");
          setRemarks("");
          setInvoiceDisplayNumber("");
          setInvoiceDate(new Date().toISOString().split("T")[0]);
          setSelectedDisbursedIds([]);
          setSelectedRows([]);
          // Reset validation errors on success
          setInvoiceNoError(false);
          setInvoiceDateError(false);
          handleCloseMisDialog();
        } else {
          const errorData = await response.text();
          setAlert(errorData || "Failed to create invoice", "error");
        }
      } catch (error) {
        setAlert("Failed to create invoice", "error");
      }
      setLoading(false);
    } else {
      setAlert("Please select DSA and disbursed IDs", "error");
    }
  };

  const formatCurrency = (value) => {
    if (value == null || isNaN(value)) return "₹0.00";
    return `₹${parseFloat(value).toFixed(2)}`;
  };

  const handleCancelInvoice = async (invoiceData) => {
    const url = URLs.cancelInvoiceUrl;
    setLoading(true);
    try {
      const payload = [invoiceData.invoiceNo];
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      });

      const responseText = await response.text();
      fetchDsaInvoiceData();

      if (!response.ok) {
        throw new Error(responseText || "Failed to Cancel Invoice");
      }

      getDsaInvoicesReceipts();
      setOpenCancelDialog(false);
      setAlert("Invoice Cancelled successfully!", "success");
    } catch (error) {
      setAlert(error.message, "error");
    }
    setLoading(false);
  };

  const formatCurrencyy = (value) => {
    if (value == null || isNaN(value)) return "₹0.00";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(value);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${date.getDate()}-${date.toLocaleString("en-US", {
      month: "short",
    })}-${date.getFullYear()}`;
  };

  const invoiceColumns = [
    {
      headerName: "Actions",
      cellRenderer: (params) => {
        const { status } = params.data;
        return (
          <>
            <Tooltip title="Approve/Print Invoice">
              <IconButton
                type="button"
                onClick={() => handleOpenInvoiceDialog(params.data)}
                color="primary"
              >
                <PrintIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel Invoice">
              <IconButton
                type="button"
                onClick={() => handleOpenCancelDialog(params.data)}
                color="error"
              >
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      filter: false,
      sortable: false,
      flex: 0.8,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sortable: true,
      flex: 1,
      valueFormatter: (params) => formatDate(params.value),
      sort: "desc",
    },
    {
      headerName: "Invoice No",
      field: "invoiceDisplayNumber",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Sub Total",
      field: "subTotal",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
    {
      headerName: "CGST",
      field: "cgst",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
    {
      headerName: "SGST",
      field: "sgst",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
    {
      headerName: "IGST",
      field: "igst",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
    {
      headerName: "Total",
      field: "total",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
  ];

  const handleCellValueChanged = (params) => {
    if (params.colDef.field === "netDsaAmount") {
      const netDsaAmount = params.newValue;
      const tdsPercent = params.data.tdsPercent || 0;

      const amount = netDsaAmount / (1 - tdsPercent / 100);
      const tdsAmount = amount - netDsaAmount;

      const updatedRow = { ...params.data, netDsaAmount, amount, tdsAmount };
      const updatedData = dsaInvoiceReceipt.map((row) => (row === params.data ? updatedRow : row));

      setDsaInvoiceReceipt(updatedData);
    }
  };

  const invoiceRecieptColumns = [
    {
      headerName: "Action",
      cellRenderer: (params) => {
        const { status } = params.data;
        return (
          <>
            {(status === 14 || status === 22) && (
              <Tooltip title="Confirm Payment">
                <IconButton onClick={() => handleOpenRecieptDailog(params.data)} color="primary">
                  <CheckCircleIcon />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
      filter: false,
      sortable: false,
      maxWidth: 120,
      flex: 0.5,
    },
    {
      headerName: "Invoice Status",
      field: "statusName",
      filter: true,
      sortable: true,
      flex: 2,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sortable: true,
      valueFormatter: (params) => formatDate(params.value),
      maxWidth: 130,
      sort: "desc",
    },
    {
      headerName: "Invoice No",
      field: "invoiceDisplayNumber",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Amount",
      field: "amount",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
    {
      headerName: "TDS %",
      field: "tdsPercent",
      filter: true,
      sortable: true,
      flex: 1,
      maxWidth: 90,
      editable: true,
      cellStyle: { textAlign: "right", fontWeight: "400" },
      valueFormatter: (params) => `${params.value ?? 0}%`,
    },
    {
      headerName: "TDS Amount",
      field: "tdsAmount",
      filter: true,
      sortable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) => formatCurrencyy(params.value),
    },
    {
      headerName: "Net Amount",
      field: "netDsaAmount",
      filter: true,
      sortable: true,
      flex: 1,
      editable: true,
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        precision: 2,
        min: 0,
      },

      cellStyle: (params) => ({
        textAlign: "right",
        fontWeight: "bold",
        backgroundColor: params.node.isSelected() ? "#f0f0f0" : "transparent",
        border: params.colDef.editable ? "1px solid #e0e0e0" : "none",
        padding: "0 8px",
      }),
      valueFormatter: (params) => formatCurrency(params.value),
    },

    {
      headerName: "DSA Code",
      field: "dsaCode",
      filter: true,
      sortable: true,
      flex: 1,
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      flex: 1,
    },
  ];

  const handleConfirmPayment = async (rowData) => {
    const netReceipt = parseFloat(rowData.netDsaAmount) || 0;
    if (!receiptDate) {
      setAlert("Please Select Amount Reciept Date", "error");
    }
    const payload = {
      receiptId: 0,
      receiptDate: receiptDate,
      invoiceNo: rowData.invoiceNo || 0,
      invoiceAmount: netReceipt + (rowData.tdsAmount || 0),
      tds: rowData.tdsAmount || 0,
      remarks: "Payment received successfully",
      netReceipt,
      isGstPaid,
      finananceId: rowData.finananceId,
      actledId: selectedBank.actledId,
    };
    setLoading(true);
    try {
      const response = await fetch(URLs.postDsaReceiptUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to confirm payment");
      }

      setOpenRecieptDialog(false);
      getDsaInvoicesReceipts();
      setAlert("Payment confirmed successfully!", "success");
    } catch (error) {
      setAlert("Failed to confirm payment. Please try again.", "error");
    }
    setLoading(false);
  };

  const handlePrintInvoice = useCallback(async (invoiceData) => {
    try {
      if (!invoiceData || !invoiceData.invoiceNo) {
        throw new Error("Invoice number is missing");
      }

      const response = await fetch(`${URLs.dsaInvoicePrintUrl}/${invoiceData.invoiceNo}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch invoice PDF");
      }
      fetchDsaInvoiceData();
      const blob = await response.blob();

      const blobUrl = URL.createObjectURL(blob);
      setOpenPrintDialog(false);

      const newWindow = window.open(blobUrl, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.focus();
          newWindow.print();
        };
      } else {
        throw new Error("Failed to open new window");
      }
    } catch (error) {
      console.error(error);
      setAlert("Error fetching invoice", "error");
    }
  }, []);

  const getDsaInvoicesReceipts = async () => {
    const url = `${URLs.dsaRecoveryInvoiceReceiptDetails}?dsaId=${user.companyId}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(url, options);
      if (response.ok) {
        const data = await response.json();
        setDsaInvoiceReceipt(data);
      } else {
        setAlert("Failed to fetch MIS data", "error");
      }
    } catch (error) {
      setAlert("An error occurred while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { label: "Raise Invoice" },
    { label: "Print Invoice" },
    { label: "Invoice Receipt" },
    { label: "Recovery" },
  ];

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          overflow: "auto",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          height: "100%",
          pt: 2,
          backgroundColor: "transparent",
        }}
      >
        {/* GST Confirmation Dialog */}
        <Dialog open={openGstDialog} onClose={() => setOpenGstDialog(false)}>
          <DialogTitle sx={{ fontSize: "1rem", fontWeight: 600 }}>GST Confirmation</DialogTitle>
          <DialogContent>
            <Typography variant="body3">
              Has GST been paid for Invoice No <strong>{confirmPayment?.invoiceNo}</strong>?
            </Typography>
          </DialogContent>
          <DialogActions>
            <StyledButton onClick={() => handleGstSelection("Y")} color="primary">
              Yes
            </StyledButton>
            <StyledButton onClick={() => handleGstSelection("N")} color="secondary">
              No
            </StyledButton>
          </DialogActions>
        </Dialog>

        {/* Receipt Confirmation Dialog */}
        <Dialog open={openRecieptDialog} onClose={handleCloseRecieptDialog}>
          <DialogContent>
            <Typography sx={dialogContentTextStyle}>
              Are you sure you want to confirm this payment for Invoice No{" "}
              <strong>{confirmPayment?.invoiceNo}</strong>?
            </Typography>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Select Date"
                  type="date"
                  value={receiptDate}
                  onChange={handleDateChange}
                  fullWidth
                  sx={{ ...MInput.b }}
                  InputLabelProps={{
                    shrink: true,
                    sx: { color: MInput.a },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Net Amount"
                  fullWidth
                  required
                  value={editableNetDsaAmount}
                  onChange={() => {}}
                  InputProps={{
                    inputComponent: CurrencyInput,
                    inputProps: {
                      value: editableNetDsaAmount,
                      decimalsLimit: 2,
                      prefix: "₹ ",
                      onValueChange: (value) => setEditableNetDsaAmount(value),
                      intlConfig: { locale: "en-IN" },
                    },
                  }}
                  sx={{ ...MInput.b }}
                  InputLabelProps={{
                    sx: { color: MInput.a },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledCancelButton
              onClick={handleCloseRecieptDialog}
              color="secondary"
              variant="outlined"
              disabled={loading}
            >
              Cancel
            </StyledCancelButton>
            <StyledButton
              onClick={handleRecieptInvoiceDialog}
              color="primary"
              variant="contained"
              disabled={
                loading || editableNetDsaAmount < 0 || isNaN(parseFloat(editableNetDsaAmount))
              }
            >
              Confirm
            </StyledButton>
          </DialogActions>
        </Dialog>

        <ConfirmationDialog
          open={openPrintDialog}
          onClose={handleCloseInvoiceDialog}
          onConfirm={handleApproveInvoiceDaialog}
          dialogText={`Are you sure you want to print/Approve this invoice of Invoice NO ${selectedInvoiceEntry.invoiceNo}?`}
        />
        <ConfirmationDialog
          open={openCancelDialog}
          onClose={handleCloseCancelDialog}
          onConfirm={handleCancelInvoiceDialog}
          dialogText={`Are you sure you want to cancel this invoice of Invoice NO ${cancleInvoice.invoiceNo}?`}
        />
        <ConfirmationDialog
          open={openMisDialog}
          onClose={handleCloseMisDialog}
          onConfirm={handleMisDialog}
          dialogText={`Are you sure you want to Raise Invoice of ${selectedDisbursedIds.length} disbursements?`}
        />

        {/* Loading Dialog */}
        <Dialog
          open={loading}
          onClose={null}
          sx={{ backgroundColor: "transparent", boxShadow: "none" }}
        >
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <CircularProgress color="primary" />
            <Typography variant="h6" sx={{ marginTop: 2, color: "white" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog>

        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>

        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleChange}
          labelColor="secondary"
          bgColor="#e0f7fa"
        />

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            mt: 0,
            pt: 2,
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
          }}
        >
          {/* ─── TAB 0: Raise Invoice ─── */}
          {activeTab === 0 && (
            <>
              <Grid container spacing={2} paddingBottom={2} pr={2} alignItems="flex-start">
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="flex-start" wrap="wrap">
                    {/* ── Left section: Invoice To, Bank, DSA, Remarks, Invoice Date ── */}
                    <Grid item xs={12} md={9}>
                      <Grid container spacing={2}>
                        {/* Invoice To */}
                        <Grid item xs={12} md={2}>
                          <Autocomplete
                            options={[
                              { id: "provider", label: "Provider" },
                              { id: "dma", label: "DMA" },
                            ]}
                            value={invoiceTo}
                            PaperComponent={CustomPaper}
                            onChange={(event, newValue) => setInvoiceTo(newValue)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Invoice To"
                                fullWidth
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": { height: "100%", minHeight: 43 },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                    "&.Mui-focused": { color: "red" },
                                  },
                                }}
                              />
                            )}
                          />
                        </Grid>

                        {/* Select Bank */}
                        <Grid item xs={12} md={3}>
                          <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "200px" }}>
                            <Autocomplete
                              options={bankAccounts}
                              getOptionLabel={(option) => `${option.actledName}`}
                              value={selectedBank}
                              onChange={handleBankChange}
                              PaperComponent={CustomPaper}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Bank"
                                  sx={{
                                    height: 43,
                                    ...MInput.b,
                                    "& .MuiInputBase-root": { height: "100%", minHeight: 43 },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: MInput.a,
                                      "&.Mui-focused": { color: "red" },
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        {/* Select DSA (only when invoiceTo is DMA) */}
                        {invoiceTo?.id === "dma" && (
                          <Grid item xs={12} md={3}>
                            <Autocomplete
                              options={dsaList || []}
                              getOptionLabel={(option) => option.dsaName || ""}
                              value={selectedDsaForInvoice}
                              onChange={(event, newValue) => setSelectedDsaForInvoice(newValue)}
                              PaperComponent={CustomPaper}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select DSA"
                                  fullWidth
                                  sx={{
                                    height: 43,
                                    ...MInput.b,
                                    "& .MuiInputBase-root": { height: "100%", minHeight: 43 },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: MInput.a,
                                      "&.Mui-focused": { color: "red" },
                                    },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        )}

                        {/* Remarks */}
                        <Grid item xs={12} md={invoiceTo?.id === "dma" ? 4 : 4}>
                          <TextField
                            label="Remarks"
                            fullWidth
                            multiline
                            rows={1}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            sx={{
                              ...MInput.b,
                              "& .MuiInputLabel-root": { fontSize: "14px" },
                            }}
                            InputLabelProps={{
                              sx: { color: MInput.a },
                            }}
                          />
                        </Grid>

                        {/* Invoice Date — with validation */}
                        <Grid item xs={12} md={2}>
                          <TextField
                            label="Invoice Date *"
                            type="date"
                            fullWidth
                            value={invoiceDate}
                            onChange={(e) => {
                              setInvoiceDate(e.target.value);
                              if (e.target.value) setInvoiceDateError(false);
                            }}
                            error={invoiceDateError}
                            helperText={invoiceDateError ? "Invoice Date is required" : ""}
                            sx={{ ...MInput.b }}
                            InputLabelProps={{
                              shrink: true,
                              sx: {
                                color: invoiceDateError ? "error.main" : MInput.a,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* ── Right section: Invoice No. (beside Submit) ── */}
                    <Grid
                      item
                      xs={12}
                      md={3}
                      display="flex"
                      flexDirection={{ xs: "column", sm: "row" }}
                      alignItems="flex-start"
                      gap={1}
                      justifyContent={{ xs: "flex-start", md: "flex-end" }}
                    >
                      {/* Invoice No. — with validation */}
                      <TextField
                        label="Invoice No. *"
                        value={invoiceDisplayNumber}
                        onChange={(e) => {
                          setInvoiceDisplayNumber(e.target.value);
                          if (e.target.value.trim()) setInvoiceNoError(false);
                        }}
                        placeholder="e.g. INV-2026-01"
                        error={invoiceNoError}
                        helperText={invoiceNoError ? "Invoice No. is required" : ""}
                        sx={{
                          ...MInput.b,
                          minWidth: 160,
                          flex: 1,
                        }}
                        InputLabelProps={{
                          sx: {
                            color: invoiceNoError ? "error.main" : MInput.a,
                          },
                        }}
                      />

                      <StyledButton
                        variant="contained"
                        onClick={handleOpenMisDialog}
                        sx={{
                          mt: "4px",
                          whiteSpace: "nowrap",
                          alignSelf: "flex-start",
                          // Shift button down when helperText appears under Invoice No.
                          ...(invoiceNoError && { mt: 0 }),
                        }}
                      >
                        Submit
                      </StyledButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ flexGrow: 1 }}
              >
                <AgGridReact
                  rowData={disbursedData}
                  columnDefs={columns}
                  pagination={true}
                  paginationPageSize={11}
                />
              </StyledAgGridContainer>
            </>
          )}

          {/* ─── TAB 1: Print Invoice ─── */}
          {activeTab === 1 && (
            <StyledAgGridContainer
              component={Paper}
              className="ag-theme-alpine"
              sx={{ flexGrow: 1 }}
            >
              <AgGridReact
                rowData={invoicedData}
                columnDefs={invoiceColumns}
                pagination={true}
                paginationPageSize={11}
                defaultColDef={{
                  filter: true,
                  sortable: true,
                  resizable: true,
                  flex: 1,
                }}
              />
            </StyledAgGridContainer>
          )}

          {/* ─── TAB 2: Invoice Receipt ─── */}
          {activeTab === 2 && (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mr: 1,
                  mb: 2,
                }}
              >
                <FormControl sx={{ minWidth: 100, width: "100%", maxWidth: "200px" }}>
                  <Autocomplete
                    options={bankAccounts}
                    getOptionLabel={(option) => `${option.actledName}`}
                    value={selectedBank}
                    onChange={handleBankChange}
                    PaperComponent={CustomPaper}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Bank"
                        sx={{
                          height: 43,
                          ...MInput.b,
                          "& .MuiInputBase-root": { height: "100%", minHeight: 43 },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: MInput.a,
                            "&.Mui-focused": { color: "red" },
                          },
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Box>

              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ flexGrow: 1 }}
              >
                <AgGridReact
                  rowData={dsaInvoiceReceipt}
                  columnDefs={invoiceRecieptColumns}
                  pagination={true}
                  paginationPageSize={11}
                  defaultColDef={{
                    filter: true,
                    sortable: true,
                    resizable: true,
                    flex: 1,
                  }}
                  onCellValueChanged={handleCellValueChanged}
                />
              </StyledAgGridContainer>
            </>
          )}
          {activeTab === 3 && <InvoiceEditor dsaId={user.dsaId} />}
        </Box>
      </Box>
    </DashboardLayout>
  );
}
